// import React, { useRef } from "react";
// import { Line } from "react-chartjs-2";

// export const ActivationSalesLineChart = (props) => {
//   const { content } = props;
//   const chartRef = useRef();

//   // if (content && content.content) {
//   //   console.log(
//   //     "last 7 days data: ",
//   //     Object.values(content.content).map((item) => item.split("/")[1])
//   //   );
//   // }
//   const data = {
//     labels: ["Day 1", "Day 2", "Day 3", "Day 4", "Day 5", "Day 6", "Day 7"],
//     datasets: [
//       {
//         datalabels: {
//           color: "white",
//         },
//         label: "Activation Trend",
//         //backgroundColor:"rgba(167, 37, 37, 0.67)",
//         //borderColor: "rgba(167, 37, 37, 0.67)",
//         //backgroundColor: ["#3e95cd", "#8e5ea2","#3cba9f","#e8c3b9","#c45850","#003f5c","#ffd166"],
//         //backgroundColor:["#ffd166","#ffd166","#ffd166","#ffd166","#ffd166","#ffd166","#ffd166"],
//         fill: true,
//         lineTension: 0.2,
//         backgroundColor: "rgb(203, 232, 254)",
//         borderColor: "rgb(162, 150, 234)",
//         borderCapStyle: "butt",
//         borderDash: [],
//         borderDashOffset: 0.0,
//         borderJoinStyle: "miter",
//         pointBorderColor: "#253BA2",
//         pointBackgroundColor: "#fff",
//         pointBorderWidth: 1,
//         pointHoverRadius: 5,
//         pointHoverBackgroundColor: "rgba(203, 232, 254,0.5)",
//         pointHoverBorderColor: "rgba(167, 37, 37, 0.67)",
//         pointHoverBorderWidth: 2,
//         pointRadius: 3,
//         pointHitRadius: 10,
//         data: content && Object.values(content),
//       },
//     ],
//   };
//   const options = {
//     scales: {
//       yAxes: [
//         {
//           ticks: {
//             beginAtZero: true,
//           },
//         },
//       ],
//     },
//     legend: { display: false },
//     title: {
//       display: false,
//     },
//   };
//   // const handleClick = (e) => {
//   //   //call for csv download
//   // };

//   return content ? (
//     <Line
//       options={options}
//       height={294}
//       width={843}
//       data-cy="line-chart"
//       data={data}
//       ref={chartRef}
//       // onElementsClick={() => handleClick()}
//     />
//   ) : null;
// };

import React, { useRef } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";

// Registering the components with ChartJS for Chart.js v3.x
ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
);

export const ActivationSalesLineChart = (props) => {
  const { content } = props;
  const chartRef = useRef();

  const data = {
    labels: ["Day 1", "Day 2", "Day 3", "Day 4", "Day 5", "Day 6", "Day 7"],
    datasets: [
      {
        label: "Activation Trend",
        fill: true,
        lineTension: 0.2,
        backgroundColor: "rgb(203, 232, 254)",
        borderColor: "rgb(162, 150, 234)",
        pointBorderColor: "#253BA2",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "rgba(203, 232, 254,0.5)",
        pointHoverBorderColor: "rgba(167, 37, 37, 0.67)",
        pointHoverBorderWidth: 2,
        pointRadius: 3,
        pointHitRadius: 10,
        data: content && Object.values(content),
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      title: { display: false },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          beginAtZero: true,
        },
      },
    },
  };

  // If you need to handle clicks on the chart
  // const handleClick = (event) => {
  //   if (chartRef.current) {
  //     const elements = chartRef.current.getElementsAtEventForMode(
  //       event,
  //       "nearest",
  //       { intersect: true },
  //       true
  //     );
  //     if (elements.length > 0) {
  //       const { datasetIndex, index } = elements[0];
  //       console.log(`Clicked on datasetIndex: ${datasetIndex}, index: ${index}`);
  //     }
  //   }
  // };

  return content ? (
    <Line
      options={options}
      height={294}
      width={843}
      data-cy="line-chart"
      data={data}
      ref={chartRef}
      // onClick={handleClick}
    />
  ) : null;
};
